import { render, staticRenderFns } from "./wallet-alerts.vue?vue&type=template&id=2072114d&"
import script from "./wallet-alerts.vue?vue&type=script&lang=js&"
export * from "./wallet-alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2072114d')) {
      api.createRecord('2072114d', component.options)
    } else {
      api.reload('2072114d', component.options)
    }
    module.hot.accept("./wallet-alerts.vue?vue&type=template&id=2072114d&", function () {
      api.rerender('2072114d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/wallet-alerts/wallet-alerts.vue"
export default component.exports